export const VIEW_OPTIONS = [
    { value: "dayGridDay", label: "Day" },
    { value: "dayGridWeek", label: "Week" },
    { value: "dayGridMonth", label: "Month" }
];
export const PERF_STYLES = {
    current: { high: { bg: '#E4F1E6', br: '#3D6846' }, low: { bg: '#F0F8F2', br: '#C8E2CF' } },
    mom: { high: { bg: '#EEE6DB', br: '#7A6650' }, low: { bg: '#F9F6F2', br: '#E2D9CC' } },
    yoy: { high: { bg: '#EAE0F5', br: '#614482' }, low: { bg: '#F6F1FB', br: '#E3D5F1' } }
};
export const ICONS = {
    status: { draft: "/assets/indi_draft.svg", proposal: "/assets/indi_proposal.svg" },
    channel: { sms: "/assets/indi_sms.svg", email: "/assets/indi_email.svg" }
};
export const INDICATION_ITEMS = [
    { icon: "/assets/indi_draft.svg", label: "Draft" },
    { icon: "/assets/indi_proposal.svg", label: "Proposal" },
    { icon: "/assets/indi_sms.svg", label: "SMS" },
    { icon: "/assets/indi_email.svg", label: "Email" },
    { icon: "/assets/indi_approve.svg", label: "Approved" },
    { icon: "/assets/indi_rejected.svg", label: "Rejected" },
    { icon: "/assets/indi_view.svg", label: "View" },
    { icon: "/assets/indi_send.svg", label: "Send" }
];
export const DEFAULT_TIME_FILTERS = {
    current: { checked: true, mode: 'High' },
    mom: { checked: true, mode: 'High' },
    yoy: { checked: true, mode: 'High' }
};
